export enum PersistStorageKeys {
    RECENT_SEARCH = 'recent-searches-storage',
    CRUMBS = 'crumbs',
    CHECKOUT = 'checkout',
    ONBOARDING = 'onboarding',
    DASHBOARD_TRAINER_RECOMMENDATIONS_BANNER = 'dashboard-trainer-recommendations-banner',
}
